var chunkMapping = {
	"0": [
		4901
	],
	"149": [
		5090
	],
	"150": [
		5091
	],
	"153": [
		5094
	],
	"154": [
		5095
	],
	"155": [
		5096
	],
	"156": [
		5097
	],
	"157": [
		5098
	],
	"158": [
		5099
	],
	"159": [
		5100
	],
	"160": [
		5101
	],
	"161": [
		5102
	],
	"162": [
		5103
	],
	"163": [
		5104
	],
	"164": [
		5105
	],
	"165": [
		5106
	],
	"166": [
		5107
	],
	"167": [
		5108
	],
	"168": [
		5109
	],
	"169": [
		5110
	]
};
var idToExternalAndNameMapping = {
	"4901": [
		"default",
		"./Containers",
		3797
	],
	"5090": [
		"default",
		"./AsyncEventTracker",
		3797
	],
	"5091": [
		"default",
		"./HostWrapper",
		3797
	],
	"5094": [
		"default",
		"./CheckoutV3",
		3797
	],
	"5095": [
		"default",
		"./CheckoutConfirmation",
		3797
	],
	"5096": [
		"default",
		"./ContactCreditCards",
		3797
	],
	"5097": [
		"default",
		"./AuditDialog",
		3797
	],
	"5098": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3797
	],
	"5099": [
		"default",
		"./InvoiceDialog",
		3797
	],
	"5100": [
		"default",
		"./PaymentDueModal",
		3797
	],
	"5101": [
		"default",
		"./PaymentModal",
		3797
	],
	"5102": [
		"default",
		"./PaymentHistory",
		3797
	],
	"5103": [
		"default",
		"./PaymentConfigurations",
		3797
	],
	"5104": [
		"default",
		"./PaymentPreferences",
		3797
	],
	"5105": [
		"default",
		"./ManagePaymentProcessing",
		3797
	],
	"5106": [
		"default",
		"./MobilePaymentsWrapper",
		3797
	],
	"5107": [
		"default",
		"./Challenge",
		3797
	],
	"5108": [
		"default",
		"./ManagePaymentMethods",
		3797
	],
	"5109": [
		"default",
		"./LightspeedReports",
		3797
	],
	"5110": [
		"default",
		"./ShippingPromotionsListContainer",
		3797
	]
};
var idToRemoteMap = {
	"4901": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5090": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5091": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5094": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5095": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5096": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5097": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5098": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5099": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5100": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5101": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5102": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5103": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5104": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5105": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5106": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5107": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5108": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5109": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5110": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}